module.exports = __webpack_public_path__ + "img/oufu_105x130x12.prt.335cf29b.jpg";